import styled from 'styled-components';
import { breakpoints } from 'config/config';

interface FarmGaleriesWrapperProps { }

export const FarmPartnersWrapper = styled.div<FarmGaleriesWrapperProps>`
  @media (max-width: ${breakpoints.xs}px) {
    padding-top: 23px;
    padding-bottom: 20px;
  }

  .mobile-farm-partners {
    display: grid;
    grid-template-columns: 1fr;

    @media (max-width: ${breakpoints.xs}px) {
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: auto;
      gap: 20px;
      padding: 0 20px;
    }

    .ant-image {
      display: none;

      @media (max-width: ${breakpoints.xs}px) {
        display: block;
      }
    }

    .partner-image {
      border: 1px solid #e1e1e1;
      border-radius: 5px;

      @media (max-width: ${breakpoints.xs}px) {
        display: block;
      }

      img {
        width: 100%;
        height: 100%;
      }
    }

    .partner-item:nth-child(odd) .partner-name {
      background-color: ${(props) => props.theme.grayBg};
    }

    .partner-item:nth-child(even) .partner-name {
      background-color: ${(props) => props.theme.white};

      @media (max-width: ${breakpoints.xs}px) {
        background-color: ${(props) => props.theme.greyBackground};
      }
    }

    .partner-name {
      line-height: 24px;
      display: block;
      padding: 10px 20px;
      font-size: 16px;
      font-weight: 500;
      color: ${(props) => props.theme.black};
      border: 1px solid ${(props) => props.theme.whiteSmoke};

      @media only screen and (max-width: ${breakpoints.lg}px) {
        font-size: 1rem;
      }

      @media (max-width: ${breakpoints.xs}px) {
        margin-top: 10px;
        padding: 0;
        line-height: unset;
        border: none;
        background-color: ${(props) => props.theme.greyBackground};
      }
    }
  }
`
